import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

const createPdfBlobUrl = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: "application/pdf" });

    return URL.createObjectURL(blob);
};

export const fetchAnswerBookletPdf = createAsyncThunk(
    "pdf/fetchAnswerBookletPdf",
    async ({ examinationCode, qpCode, bookletCode }, { rejectWithValue }) => {
    
        try {
            const response = await api.get(
                `/v1/Booklet/${examinationCode}/${qpCode}/${bookletCode}/pdf`,
            );
        //    const response = await api.get(
        //         `/v1/QuestionPaper/${examinationCode}/${qpCode}/answer-hints-pdf`,
        //     );
            return createPdfBlobUrl(response.data.data);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const AnswerBookletPdfSlice = createSlice({
    name: "AnswerBookletPdfSlice",
    initialState: {
        pdfUrl: "",
        loading: false,
        error: null,
        currentRequestId: null,
    },
    reducers: {
        clearAnswerBookletPdf(state) {
            state.pdfUrl = "";
            state.loading = false;
            state.error = null;
            state.currentRequestId = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnswerBookletPdf.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.pdfUrl = "";
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(fetchAnswerBookletPdf.fulfilled, (state, action) => {
                if (state.currentRequestId !== action.meta.requestId) return;
                state.loading = false;
                state.pdfUrl = action.payload;
                state.currentRequestId = null;
            })
            .addCase(fetchAnswerBookletPdf.rejected, (state, action) => {
                if (state.currentRequestId !== action.meta.requestId) return;
                state.loading = false;
                state.error = action.payload;
                state.pdfUrl = "";
                state.currentRequestId = null;
            });
    },
});

export const { clearAnswerBookletPdf } = AnswerBookletPdfSlice.actions;
export default AnswerBookletPdfSlice.reducer;
